/**
 * Action types enum
 * This centralizes all action types in one place for better maintainability
 */
export enum ActionTypes {
  // Beer data actions
  FETCH_BEERS_START = 'FETCH_BEERS_START',
  FETCH_BEERS_SUCCESS = 'FETCH_BEERS_SUCCESS',
  FETCH_BEERS_FAILURE = 'FETCH_BEERS_FAILURE',
  UPDATE_BEER_PROPERTY = 'UPDATE_BEER_PROPERTY',
  
  // Filter actions
  SET_SEARCH_TERM = 'SET_SEARCH_TERM',
  SET_TYPE_FILTER = 'SET_TYPE_FILTER',
  SET_BREWERY_FILTER = 'SET_BREWERY_FILTER',
  SET_DRINK_TYPE_FILTER = 'SET_DRINK_TYPE_FILTER',
  SET_AVAILABILITY_FILTER = 'SET_AVAILABILITY_FILTER',
  ADD_TAG_FILTER = 'ADD_TAG_FILTER',
  REMOVE_TAG_FILTER = 'REMOVE_TAG_FILTER',
  CLEAR_TAG_FILTERS = 'CLEAR_TAG_FILTERS',
  CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS',
  SET_SHOW_ONLY_FAVORITES = 'SET_SHOW_ONLY_FAVORITES',
  SET_SHOW_ONLY_AVAILABLE = 'SET_SHOW_ONLY_AVAILABLE',
  SET_FILTER_BY_FAVORITES = 'SET_FILTER_BY_FAVORITES',
  
  // User interaction actions
  TOGGLE_FAVORITE = 'TOGGLE_FAVORITE',
  UPDATE_RATING = 'UPDATE_RATING',
  UPDATE_NOTES = 'UPDATE_NOTES',
  TOGGLE_TASTING_LIST = 'TOGGLE_TASTING_LIST',
  TOGGLE_TRIED = 'TOGGLE_TRIED',
  SET_USER_INTERACTIONS = 'SET_USER_INTERACTIONS',
  
  // UI state actions
  SET_ACTIVE_TAB = 'SET_ACTIVE_TAB',
  SET_HAS_ACTIVE_FILTERS = 'SET_HAS_ACTIVE_FILTERS',
  SET_SELECTED_BEER = 'SET_SELECTED_BEER',
  CLEAR_SELECTED_BEER = 'CLEAR_SELECTED_BEER',
  SET_FILTER_BAR_HEIGHT = 'SET_FILTER_BAR_HEIGHT',
}
